import { TwoUserStack } from "@circle-react-uikit/TwoUserStack";
import type { TwoUserStackProps } from "@circle-react-uikit/TwoUserStack";
import { Avatar as AvatarCompass } from "@circleco/compass/components/Avatar";

import { usePunditUserContext } from "@/react/contexts/punditUserContext";
import { userStatusToAvatarStatus } from "@/react/helpers/compass/userStatusToAvatarStatus";

import type { OtherParticipant } from "../ChatRoomTypes";

export interface AvatarProps {
  isDirect: boolean;
  otherParticipants: OtherParticipant[];
}

export const Avatar = ({ isDirect, otherParticipants }: AvatarProps) => {
  const { currentCommunityMember } = usePunditUserContext();

  if (isDirect) {
    const [user] = otherParticipants;
    const { avatar_url: src, name, status } = user || {};
    const compassStatus = userStatusToAvatarStatus(status);
    return (
      <AvatarCompass src={src} name={name} status={compassStatus} size="md" />
    );
  }

  if (otherParticipants.length === 0) {
    const { avatar_url: src, name } = currentCommunityMember ?? {};
    return <AvatarCompass src={src} name={name} size="md" />;
  }

  if (otherParticipants.length === 1) {
    const { avatar_url: src, name } = otherParticipants[0];
    return <AvatarCompass src={src} name={name} size="md" />;
  }

  const toUser = (p: OtherParticipant) => ({ name: p.name, src: p.avatar_url });
  const users: TwoUserStackProps["users"] = [
    toUser(otherParticipants[0]),
    toUser(otherParticipants[1]),
  ];

  return <TwoUserStack isFullRounded users={users} />;
};
